import {
  any, bool, shape, string, func, number,
} from 'prop-types';
import React, { useState } from 'react';

import { getReturnUrlByDestination, composeDestinationQuerystring } from '../../../shared-with-server/destination-utils';
import Logo from '../../components/Logo';
import { destinationInfo } from '../../destructured-front-end-config';
import { PageWrapUAM } from '../../styles-and-themes/styles/uam-page-wrap';
import MiniFooterV2 from '../../components/composite/MiniFooterV2/MiniFooterV2';
import { getIdTokenIfValid } from '../../utils/jwt-utils';
import { BasePageUAMOuterContainer, BasePageUAMHeaderContainer, BasePageUAMContentContainer } from './BasePageUAMStyles';
import UAMTabs from '../../components/UAMTabs/UAMTabs';
import NotFoundPanel from '../NotFoundPage/Panels/NotFoundPanel';
import PredefinedResources from '../../components/PredefinedResources';

const BasePageUAM = ({
  brand,
  destPath,
  needsDestPath,
  showTabs,
  activeTab,
  needsToBeAuthenticated,
  children,
}) => {
  const [isAuthenticated] = useState(
    () => needsToBeAuthenticated && (!!getIdTokenIfValid('id_token') || !!getIdTokenIfValid('oidc_id_token')),
  );

  const [isDestPathProvided] = useState(
    () => needsDestPath && (getReturnUrlByDestination(destinationInfo, destPath?.dest, destPath?.path) || destPath?.retURL)?.length > 0,
  );

  if (needsToBeAuthenticated && !isAuthenticated) {
    window.location.href = `/login?${composeDestinationQuerystring(destinationInfo, destPath)}`;
    return <></>;
  }

  return (
    <PageWrapUAM>
      <PredefinedResources />
      <BasePageUAMOuterContainer>
        <BasePageUAMHeaderContainer>
          <Logo brand={brand} />
        </BasePageUAMHeaderContainer>

        <BasePageUAMContentContainer>
          <div className="formContent">
            {
              showTabs && isDestPathProvided && (
                <UAMTabs
                  activeTab={activeTab}
                  destPath={destPath}
                />
              )
            }

            {
              /* TODO: Ensure back-end code changes status to 404 for dest/path issue */
              !needsDestPath || isDestPathProvided
                ? children
                : <NotFoundPanel title="Page Not Found" error="pageNotFound" brand={brand} />
            }
          </div>
        </BasePageUAMContentContainer>

        <MiniFooterV2 brand={brand} />
      </BasePageUAMOuterContainer>
    </PageWrapUAM>
  );
};

BasePageUAM.propTypes = {
  destPath: shape({
    dest: string,
    path: string,
    retURL: string,
  }),
  brand: shape({
    short: string.isRequired,
    full: string.isRequired,
  }).isRequired,
  needsDestPath: bool,
  showTabs: bool,
  activeTab: number,
  tabSettings: shape({
    onSignInClick: func.isRequired,
    onCreateAccountClick: func.isRequired,
    activeTab: number.isRequired,
    setActiveTab: func.isRequired,
  }),
  needsToBeAuthenticated: bool,
  children: any.isRequired,
};

BasePageUAM.defaultProps = {
  needsDestPath: false,
  showTabs: true,
  needsToBeAuthenticated: false,
  tabSettings: null,
  activeTab: 1,
  destPath: {
    retURL: null,
  },
};

export default BasePageUAM;
